export var ToastTypes={
    TOAST_SUCCESS:"success",
    TOAST_SUCCESS_TITLE:"Success",
    TOAST_ERROR:"error",
    TOAST_ERROR_TITLE:"Error",
    TOAST_WARNING:"warning",
    TOAST_WARNING_TITLE:"Warning"
}

export const menuItems = [
	{ label: 'Dashboard', path: '/dashboard' },
	{
		label: 'Website',
    permissions: ['SEO'],
		subMenu: [{ label: 'Website List', path: '/website-list' }],
	},
	{
		label: 'Category Management',
		subMenu: [{ label: 'Global Category List', path: '/global-category-list' }],
	},
	{
		label: 'Product Management',
		subMenu: [{ label: 'Global Product List', path: '/global-product-list' }],
	},
	{
		label: 'My Account',
		subMenu: [
			{ label: 'Edit Profile', path: '/dashboard/editprofile' },
			{ label: 'Change Password', path: '/' },
		],
	},
	{
		label: 'Data',
		subMenu: [{ label: 'Party Listing', path: '/party-listing' }],
	},
	{
		label: 'Posts',
		subMenu: [
			// { label: "App Posting", path: "/dashboard/app-posting" },
			{ label: 'App Posting', path: '/dashboard/app-postings' },
			{ label: 'Create A Post', path: '/dashboard/create-post' },
		],
	},
	{
		label: 'Inquiry',
		subMenu: [{ label: 'Inquiry', path: '/dashboard/inquiry' }],
	},
	{
		label: 'Security',
		subMenu: [{ label: 'Manage User Roles', path: '/dashboard' }],
	},
	{
		label: 'UI/UX',
		subMenu: [{ label: 'Template Features', path: '/dashboard' }],
	},
	// {
	//   label: "Backend",
	//   subMenu: [
	//     { label: "OpenApi(custom)", path: "/" },
	//     { label: "OpenApi(Yancy)", path: "/" },
	//     { label: "Yancy CMS", path: "/" },
	//   ],
	// },
	{
		label:<div className="d-flex flex-column"> <span>Portal SEO </span> <span style={{fontSize:8, color: '#999', marginLeft: 3}}>BABBUSIYA.COM</span></div>,
    	permissions: ['SEO'],
		subMenu: [
			{ label: 'URL List', path: '/url-list' },
			{ label: 'Add URL', path: '/url-screen' },
		],
	},
];